<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  let dispatch = createEventDispatcher();
</script>

<button on:click={e => dispatch('click', e)}>
  <slot />
</button>

<style>
  button {
    height: 30px;
    width: 30px;
    border-radius: 6px;
    transition: all 0.3s;
    border: none;
    background: transparent;
    color: var(--loop-foreground);
    padding: 0px;
  }

  button:hover {
    background: var(--loop-accent1);
  }
</style>
